import { CgGroupingLevel, SizingGroup, TreeNode, TreeData } from '../../models/sizing-group';

export function getAllowedCgLevels(groupingCgLevel: CgGroupingLevel): string[] {
  switch (groupingCgLevel) {
    case CgGroupingLevel.CG3:
      return ['CG1', 'CG2', CgGroupingLevel.CG3];
    case CgGroupingLevel.CG4:
      return ['CG1', 'CG2', CgGroupingLevel.CG3, CgGroupingLevel.CG4];
    case CgGroupingLevel.CG5:
      return ['CG1', 'CG2', CgGroupingLevel.CG3, CgGroupingLevel.CG4, CgGroupingLevel.CG5];
  }
}

function createTreeNode(obj: TreeNode, name: string, disabled: boolean, cgLevel: string): TreeNode {
  if (obj) {
    obj.disabled = obj.disabled && disabled;
    return obj;
  }

  return {
    name,
    disabled,
    cgLevel,
    children: {},
  };
}

export function getTreeData(groups: SizingGroup[], showNonReviewed: boolean): TreeData {
  const groupIds = groups.map((group) => group.groupId);

  return groups.reduce((acc: TreeData, group) => {
    // need to copy the codes into a new array to avoid mobx warning about `mobx [mobx] Out of bounds read: X`
    const [cg1Name, cg2Name, cg3Name, cg4Name, cg5Name] = [...group.commodityGroup.names];
    const [cg1Key, cg2Key, cg3Key, cg4Key, cg5Key] = [...group.commodityGroup.codes];
    const disabled = group.isReviewed && showNonReviewed;

    acc[cg1Key] = createTreeNode(acc[cg1Key], cg1Name, disabled, 'CG1');
    acc[cg1Key].disabled = true;

    if (cg2Key) {
      acc[cg1Key].children[cg2Key] = createTreeNode(acc[cg1Key].children[cg2Key], cg2Name, disabled, 'CG2');
      acc[cg1Key].children[cg2Key].disabled = true;

      const cg2Children = acc[cg1Key].children[cg2Key].children;

      cg2Children[cg3Key] = createTreeNode(cg2Children[cg3Key], cg3Name, disabled, CgGroupingLevel.CG3);

      if (!groupIds.includes(cg3Key)) {
        cg2Children[cg3Key].disabled = true;
      }

      if (cg4Key) {
        cg2Children[cg3Key].children[cg4Key] = createTreeNode(
          cg2Children[cg3Key].children[cg4Key],
          cg4Name,
          disabled,
          CgGroupingLevel.CG4
        );

        if (!groupIds.includes(cg4Key)) {
          cg2Children[cg3Key].children[cg4Key].disabled = true;
        }
      }

      if (cg5Key && groupIds.includes(cg5Key)) {
        cg2Children[cg3Key].children[cg4Key].children[cg5Key] = createTreeNode(
          cg2Children[cg3Key].children[cg4Key].children[cg5Key],
          cg5Name,
          disabled,
          CgGroupingLevel.CG5
        );
      }
    }

    return acc;
  }, {});
}
